import AdvancedController from "./advanced-controller"
import { Breakpoints } from "../utils/breakpoints"

export default class ContactBubbleController extends AdvancedController {

  static targets = ['element'];

  static values = {
    isClosed: Boolean
  }

  connect() {
    super.connect();

    this.breakpoints = new Breakpoints();

    if (localStorage.getItem("yasoon-contact-bubble-closed") || this.breakpoints.breakpointDown('sm')) {
      this.isClosedValue = true;
      this.close();
    } else {
      this.isClosedValue = false;
      this.open();
    }

  }

  open() {
    this.elementTarget.classList.add('--is-opened');
    this.elementTarget.classList.remove('--is-closed');
    localStorage.removeItem("yasoon-contact-bubble-closed");
    this.isClosedValue = false;
  }

  close() {
    this.elementTarget.classList.remove('--is-opened');
    this.elementTarget.classList.add('--is-closed');
    localStorage.setItem("yasoon-contact-bubble-closed", true);
    this.isClosedValue = true;
  }

  toggleState({ params }) {
    if (this.isClosedValue && params.origin == 'open') {
      this.open();
    } else if (!this.isClosedValue && params.origin == 'close') {
      this.close();
    }
  }
}